import React, { useState, useEffect } from 'react';
import {
    CSSTransition,
    SwitchTransition,
} from 'react-transition-group';

import StepperHeader from "./StepperHeader";
import StepperFooter from "./StepperFooter";
import BubbleButton from "./BubbleButton";
import Loader from "./Loader";
import ProductItem from './Product';
import { ProgressBar } from "./ProgressBar";

export const Stepper = ( { base_url } ) => {
    const totalSteps = 7;
    const [currentStep, setCurrentStep] = useState(1);
    const [currentScore, setCurrentScore] = useState(0);
    const [prevScore, setPrevScore] = useState(0);

    // Percentage Value of steps
    const percent = 100 * currentStep / totalSteps;

    // Fist and last steps
    const is_first = (currentStep === 1);
    const is_last = (currentStep === totalSteps);

    // Handle form change
    const handleOnClick = (event) => {
        setCurrentScore(currentScore + parseInt(event.target.value))
        setPrevScore(parseInt(event.target.value))

        next();
    };

    // Move to next step
    const next = () => {
        setCurrentStep(currentStep + 1);
    };

    // Move to previous step
    const back = () => {
        setCurrentScore(currentScore - prevScore)
        setCurrentStep(currentStep - 1);
    };

    // Init view
    let view;
    let heading;
    let items;
    let showResults = false;

    switch (currentStep) {
        case 1:
            heading = `Wie alt bist Du?`;
            items = [
                {
                    text: '5-15 Jahre',
                    value: 1,
                },
                {
                    text: '16-35 Jahre',
                    value: 2,
                },
                {
                    text: '36-55 Jahre',
                    value: 3,
                },
                {
                    text: 'Über 55 Jahre',
                    value: 4,
                },
            ]
            break;
        case 2:
            heading = `Wie groß bist Du?`;
            items = [
                {
                    text: '100cm - 150cm',
                    value: 1,
                },
                {
                    text: '150cm - 185cm',
                    value: 2,
                },
                {
                    text: 'Über 185cm',
                    value: 3,
                },
            ]
            break;
        case 3:
            heading = `Wie schwer bist Du?`;
            items = [
                {
                    text: 'Leicht',
                    value: 1,
                },
                {
                    text: 'Normal',
                    value: 2,
                },
                {
                    text: 'Schwer',
                    value: 3,
                },
            ]
            break;
        case 4:
            heading = `Wie sportlich bist Du?`;
            items = [
                {
                    text: 'Kein Sport',
                    value: 1,
                },
                {
                    text: 'Sportlich',
                    value: 2,
                },
                {
                    text: 'Sportler',
                    value: 3,
                },
            ]
            break;
        case 5:
            heading = `Welche Beschwerden hast Du?`;
            items = [
                {
                    text: 'Hüfte',
                    value: 1,
                },
                {
                    text: 'Rücken',
                    value: 2,
                },
                {
                    text: 'Knie',
                    value: 3,
                },
                {
                    text: 'Schulter',
                    value: 3,
                },
                {
                    text: 'Ich habe keine Beschwerden',
                    value: 0,
                    lightDisply: true
                },
            ]
            break;
        case 6:
            heading = `Hast Du orthopädische Vorerkrankungen?`;
            items = [
                {
                    text: 'Keine',
                    value: 1,
                },
                {
                    text: 'Nicht wirklich',
                    value: 2,
                },
                {
                    text: 'Starke Schmerzen',
                    value: 3,
                }
            ]
            break;
        case 7:
            heading = `Wir empfehlen dir`;
            showResults = true;
            break;
        default:
            items = []
    }

    if(!showResults && items) {
        view = <Step
            handleOnClick={handleOnClick}
            goBack={(currentStep > 1 ? back : null)}
            currentScore={(currentScore > 0 ? currentScore : null)}
            heading={heading}
            items={items}
        />
    } else if(showResults) {
        view = <StepResults
            heading={heading}
            goBack={(currentStep > 1 ? back : null)}
            currentScore={(currentScore > 0 ? currentScore : null)}
            setCurrentStep={setCurrentStep}
            setCurrentScore={setCurrentScore}
            setPrevScore={setPrevScore}
        />
    }

    return (
        <div>
            <SwitchTransition mode={`out-in`}>
                <CSSTransition key={currentStep} timeout={500} classNames="fade">
                    {view}
                </CSSTransition>
            </SwitchTransition>

            {(!is_last) && <ProgressBar percent={percent} />}
        </div>
    )
}

const Step = ( { handleOnClick, heading, items, goBack, currentScore } ) => {
    return (
        <div className="step">
            <StepperHeader text={heading} />

            <div className="finder-body py-3">
                <div className="row">
                    {items.map((item, key) => {
                        if( item.lightDisply ) {
                            return (
                                <div key={key} className="col-12 mt-3 mx-auto text-center">
                                    <button className="btn btn-link" onClick={handleOnClick} value={item.value}>{item.text}</button>
                                </div>
                            );
                        } else {
                            return (
                                <div key={key} className="col-6 col-sm-6 col-md-3 mx-auto text-center">
                                    <BubbleButton text={item.text} value={item.value} handleOnClick={handleOnClick} />
                                </div>
                            );
                        }
                    })}
                </div>
            </div>

            <StepperFooter goBack={goBack} currentScore={currentScore} />
        </div>
    )
}

const StepResults = ( { heading, currentScore, goBack, setCurrentStep, setCurrentScore, setPrevScore } ) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showFooter, setShowFooter] = useState(false);
    const [showInfoText, setShowInfoText] = useState(false);
    const [results, setResults] = useState([]);

    const resetFinder = () => {
        setCurrentStep(1);
        setCurrentScore(0)
        setPrevScore(0)
    }

    const fetchProductsFromApi = () => {
        setIsLoading(true);

        if(currentScore < 17) {
            fetch("/wp-json/backpress-finder/v2/products_by_value/?" + new URLSearchParams({
                backpress_value: currentScore
            }))
                .then((resp) => resp.json())
                .then(function(data) {
                    setResults(data)
                    setIsLoading(false);
                    setShowFooter(true);
                })
                .catch(function(error) {
                    setShowInfoText(true);
                    setIsLoading(false);
                    setShowFooter(true);
                });
        } else {
            setShowInfoText(true);
            setIsLoading(false);
            setShowFooter(true);
        }
    }

    useEffect(() => {
        fetchProductsFromApi()
    }, []);

    return (
        <div className="step">
            <StepperHeader text={heading} />

            <div className="finder-body py-3">
                {showInfoText && <div className="row"><div className="col-12 col-md-8 col-lg-6 mx-auto text-center">
                        <p className="lead">
                            Leider konnten wir keinen backpress® für dich finden. Unsere Physiotherapeuten beraten dich gerne und helfen dir, eine Lösung für dein Rückenproblem zu finden.
                        </p>
                        <a className="btn btn-primary" href="/kontakt/?ref=Finder-No-Result">Kontakt</a>
                    </div></div>}
                <div className="row">
                    <div className="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mx-auto text-center">
                        {isLoading && <Loader />}
                        {results && results.map((product, i) => {
                            return <ProductItem key={i} product={product} />
                        })}
                    </div>
                </div>
            </div>

            {showFooter && <StepperFooter goBack={resetFinder} currentScore={currentScore} stepResults={true}/>}
        </div>
    )
}
